import { SVGProps } from "react"

const KeyBoardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_27353_230895)">
      <path
        d="M14.0007 2.33301H2.00065C1.82384 2.33301 1.65427 2.40325 1.52925 2.52827C1.40422 2.65329 1.33398 2.82286 1.33398 2.99967V12.333C1.33398 12.5098 1.40422 12.6794 1.52925 12.8044C1.65427 12.9294 1.82384 12.9997 2.00065 12.9997H14.0007C14.1775 12.9997 14.347 12.9294 14.4721 12.8044C14.5971 12.6794 14.6673 12.5098 14.6673 12.333V2.99967C14.6673 2.82286 14.5971 2.65329 14.4721 2.52827C14.347 2.40325 14.1775 2.33301 14.0007 2.33301V2.33301Z"
        stroke="currentColor"
        stroke-width="1.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 6.33301H4.66667"
        stroke="currentColor"
        stroke-width="1.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 6.33301H7.66667"
        stroke="currentColor"
        stroke-width="1.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.66602 6.33301H11.9993"
        stroke="currentColor"
        stroke-width="1.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 9.33301H12"
        stroke="currentColor"
        stroke-width="1.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_27353_230895">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default KeyBoardIcon
